
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.391","height":"18.731"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 371"}},[_c('path',{attrs:{"data-name":"Rectángulo 261","fill":"#fff","d":"M.634 2.243h17.122v15.854H.634z"}}),_c('path',{attrs:{"data-name":"Rectángulo 262","fill":"#f1f1f1","d":"M.634 2.243h17.122v15.854H.634z"}}),_c('path',{attrs:{"data-name":"Unión 3","d":"M.634 18.731A.634.634 0 010 18.1V2.243a.634.634 0 01.634-.634h4.122V.634a.634.634 0 011.268 0v.975h6.342V.634a.634.634 0 011.268 0v.975h4.122a.634.634 0 01.634.634V18.1a.634.634 0 01-.634.634zm16.489-1.268V7.316H1.268v10.147zm0-11.415V2.877h-3.488v.975a.634.634 0 01-1.268 0v-.975H6.025v.975a.634.634 0 01-1.268 0v-.975H1.268v3.171z","fill":"#c6c6c6"}})])])
          )
        }
      }
    